<script setup>

</script>

<template>
    <table class="min-w-full">
        <slot/>
    </table>
</template>
